import { Component, OnInit } from '@angular/core';
import { LookupService } from '../../../../shared/services/lookup.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { LookUp } from '../../../../shared/models/look-up.model';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { AttachmentType, NearestLocation, Service, Languages, UnitType, NearestLocationForDynamicBalancing } from '../../../../../shared/models/enums.model';
import { fileService } from '../../../../shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { Attachment } from '../../../../shared/models/attachment.model';
import { QualityRequestDTO } from '../../../models/quality-Request-DTO.model';
import { QualityRequestService } from '../../../services/quality-request.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
//import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { CustomValidators } from '../../../models/custom-validator';
//import { invalid } from '@angular/compiler/src/render3/view/util';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-dynamic-balancing-request',
  templateUrl: './dynamic-balancing-request.component.html',
  styleUrls: ['./dynamic-balancing-request.component.css']
})
export class DynamicBalancingRequestComponent implements OnInit {
  dynamicbalancingRequestForm: FormGroup;
  typeOfUnit: LookUp[];
  isReadOnly: boolean = false;
  model: QualityRequestDTO;
  showSuccessMessage: boolean;
  showUnsuccessMessage: boolean;
  nearestLocation = NearestLocationForDynamicBalancing;
  submitted = false;
  loading = false;
  responseObject: ResponseObject;
  attachments: Attachment[] = [];
  requestId: any;
  drawingAttachmentUrl;
  displayedLang: string;
  drawingsFileProgress: number;
  nearestLocationKeys = Object.keys(this.nearestLocation);
  numberRegex: string = '^[0-9]*$';
  charRegex: string = '^[a-zA-Z\\s]*$';
  fractionRegex: string = '^((([0-9])*)((\\.[0-9]{1,7})?)|([0-9])+((\\.[0-9]{1,7}))|([0-9])+((\\.)))$';
  testedDiv: number;
  unitType: UnitType;
  showOtherDiv: boolean;
  showRequest = true;
  responseObj: ResponseObject;
  isErrorMessage: boolean = false;
  userInfo: any;
  IsFileExtention: boolean = false;
  IsFileSize: boolean = false;
  baseRequestDTO: BaseRequest;
  drawingAttachmentExist : string;


  constructor(private formBuilder: FormBuilder,
    private lookupService: LookupService,
    private fileService: fileService,
    private translate: TranslateService,
    private qualityRequestService: QualityRequestService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private globalSrv: GlobalServices,
    private authSrevice: AuthenticationService) {

    if (history.state.data && history.state.data.requestId)
      this.requestId = history.state.data.requestId;
    // this.requestId = this.route.snapshot.params.Id;
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.model = new QualityRequestDTO();
    this.nearestLocationKeys = this.nearestLocationKeys.slice(this.nearestLocationKeys.length / 2);
    this.buildForm(null);
  }

  ngOnInit() {


    this.isReadOnly = this.requestId != null ? true : false;
    if (history.state.data && history.state.data.isCompleted) {
      this.isReadOnly = true;
    }else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }
    this.getLookUps();
    if (this.requestId) {
      this.getQualityRequest();
    }

  }

  buildForm(otherUnitType) {

    this.dynamicbalancingRequestForm = this.formBuilder.group({
      DesiredDate: ['', [Validators.required, CustomValidators.dateValidator()]],
      Description: ['', [Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
      TypeOfUnitId: [null],
      Drawings: [''],
      UnitWeight: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      OperatingSpeed: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      NearestLocation: [''],
      TermsAndConditions: [false, [Validators.requiredTrue]],
      VesselName: ['', [Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
    });
  }

  getQualityRequest() {
    this.qualityRequestService.getQualityRequest(this.requestId).subscribe(
      d => {
        this.changeUnit(d.Data.TypeOfUnitId);
        this.model = d.Data;
        this.dynamicbalancingRequestForm.patchValue({
          DesiredDate: new Date(this.model.DesiredDate),
          Description: this.model.Description,
          TypeOfUnitId: this.model.TypeOfUnitId,
          UnitWeight: this.model.UnitWeight,
          OperatingSpeed: this.model.OperatingSpeed,
          VesselName: this.model.VesselName,
          NearestLocation: this.model.NearestLocation,
          MobileNumber: this.model.MobileNumber,
          Fax: this.model.Fax,
          CustomerName: this.model.CustomerName,
          OthersTypeOfUnit: this.model.OthersTypeOfUnit,
          TermsAndConditions: true
        });
        this.baseRequestDTO = this.model.baseRequest;
        this.userInfo = {
          MobileNumber: this.model.MobileNumber,
          Fax: this.model.Fax,
          CustomerName: this.model.CustomerName
        };
        var baseUrl = AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder = AppConfig.settings.apiServer.ShipyardUploadsFolder;
        this.drawingAttachmentUrl = this.model.Attachments.find(x => x.AttachmentType == AttachmentType.DynamicBalancing) != undefined ?
          this.model.Attachments.find(x => x.AttachmentType == AttachmentType.DynamicBalancing).URL : '';
        this.drawingAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.drawingAttachmentUrl;
       this.drawingAttachmentExist = this.drawingAttachmentUrl.substring(this.drawingAttachmentUrl.lastIndexOf('/') + 1);
      }
    );
  }
  test() {

  }
  getLookUps() {

    //Get type of unit Lookup
    this.lookupService.GetUnitTypes().subscribe(
      d => {
        this.typeOfUnit = d.Data;
      }
    );
  }

  public async onFileSelected(event,currFormControl, docName, attachmentType: AttachmentType, progressVariableName, key) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      var formControlName = event.target.attributes['formControlName'].value;
      this.dynamicbalancingRequestForm.controls[formControlName].setValue("");
      var errorMessageExtension = await this.translate.get('FRONT_USER.Floating_Carnes_Request_Form.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessageExtension);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElements && invalidElements.length>0) {
      //   invalidElements[0].scrollIntoView();
      // }

    }

    if (!this.fileService.IsFileSizeValid(event)) {

      var formControlName = event.target.attributes['formControlName'].value;
      this.dynamicbalancingRequestForm.controls[formControlName].setValue("");
      var errorMessage = await this.translate.get('FRONT_USER.MaxFileSizeTitle').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElement && invalidElement.length>0) {
      //   invalidElement[0].scrollIntoView();
      // }
      return false;
      // .subscribe((res: string) => {
      //   alert(res);
      //   return false;
      // });

    }


    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);
    this.fileService.fileUploader(formData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total)

          this[progressVariableName] = percentDone;
          currFormControl.setErrors({'invalid': true});
        } else if (event instanceof HttpResponse) {
          var jsonResponse = event.body.Data;
          var Url = jsonResponse.Url;
          var attachment = new Attachment();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          this.attachments = this.attachments.filter(h => h.DocumentName != docName);
          this.attachments.push(attachment);
          currFormControl.setErrors(null);
        }
      }
    );
  }

  changeUnit(value) {
    this.unitType = value;
    this.dynamicbalancingRequestForm.patchValue({
      otherUnitType: value,
    });
    this.dynamicbalancingRequestForm.updateValueAndValidity();
    if (this.unitType == UnitType.Other) {
      this.showOtherDiv = true;
      this.dynamicbalancingRequestForm.addControl('OthersTypeOfUnit', new FormControl('', [Validators.required]));
    }

    else {
      if (this.dynamicbalancingRequestForm.controls['OthersTypeOfUnit'] != null) {
        this.dynamicbalancingRequestForm.removeControl('OthersTypeOfUnit');
      }
      this.showOtherDiv = false;
    }
  }

  get f() {
    return this.dynamicbalancingRequestForm.controls;
  }

  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.dynamicbalancingRequestForm.invalid) {
      return;
    }
    // this.dynamicbalancingRequestForm.controls['MobileNumber'].setValue(this.dynamicbalancingRequestForm.controls.MobileNumber.value.internationalNumber);
    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    this.model = this.dynamicbalancingRequestForm.getRawValue();
    this.model.MobileNumber = this.dynamicbalancingRequestForm.controls.MobileNumber.value;
    //this.model.NearestLocation = this.nearestLocation.Suez;
    this.model.ServiceId = Service.DynamicBalancing;
    this.model.RequestorId = this.authSrevice.currentUserValue.UserId;
    this.model.Attachments = this.attachments;
    this.model.Drawings = this.attachments.length !== 0 ? this.attachments[0].URL : "";
    this.qualityRequestService.addQualityRequest(this.model).subscribe(

      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          let message: string;
          this.dynamicbalancingRequestForm.reset();
          this.showRequest = false;
          this.loading = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
          // console.log("Fail");
        }

      });
  }

  goToTermsAndConditions(): void {
    if (this.globalSrv.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }
}
